import { Modal } from 'design-library';
import { ProjectSubmissionDetails } from '../project-submission-details';
import { IProject } from 'common/models';
import { useProjectFiles } from 'admin/hooks';

export default function ProjectSubmissionDetailsModal({
  isShown,
  onCancel,
  selectedProject,
}: {
  selectedProject: IProject;
  isShown: boolean;
  onCancel: () => void;
}) {
  const { projectFiles } = useProjectFiles(selectedProject.id);

  return (
    <Modal isShown={isShown} onCancel={onCancel} size="medium">
      <ProjectSubmissionDetails
        project={selectedProject}
        projectFiles={projectFiles}
      />
    </Modal>
  );
}
